import Card from "components/card";
import { IoInformationCircleOutline } from "react-icons/io5";


const Widget = ({ icon, title, subtitle }) => {
  return (
    <Card extra="!flex-row flex-grow items-center rounded-md dashboard-card-wrap" >
      {/* <div className="ml-[18px] flex h-[150px] w-auto flex-row items-center">
        <div className="rounded-full bg-lightPrimary p-3 dark:bg-navy-700">
          <span className="flex items-center text-[#2369d2] dark:text-white">
            {icon}
          </span>
        </div>
      </div> */}

      <div className="h-[100%] ml-4 flex w-[100%] flex-col justify-between gap-[25px]">
        <div className="flex items-center gap-[10px] justify-between ">
        <p className="font-dm text-[18px] font-[500] text-[#262729]">{title}</p>
        <div>
        <IoInformationCircleOutline className="font-[20px]" style={{fontSize:"24px"}}/>
        </div>
        </div>
        <h4 className="text-[26px] font-[600] text-[#16181e] dark:text-white">
          {subtitle}
        </h4>
      </div>
    </Card>
  );
};

export default Widget;
